import React from 'react';

import classNames from "classnames";
import {observer} from "mobx-react";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ACTION_TYPES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import {Link} from "../../../core/components/link/link";
import styles from "../styles/entity-scores-empty-state.module.scss";
import {ENTITY_SCORES} from "../entity-scores-widget.consts";
import {SportTypeEmptyState} from "../../../core/components/scores-placeholders/empty-state/sport-type-empty.state";

export class EntityScoresWidgetEmptyStateProps extends BaseProps {}

export const EntityScoresWidgetEmptyState = observer(({controller, onFilterChange}: EntityScoresWidgetEmptyStateProps) => {
  const {state, device: {isSmallView}} = controller;
  const {entity, filterName, filterEmptyStateModel, emptyStateText, emptyStateButtonLabel, filterEmptyStateIndex, hasGames, sport} = state;
  const linkButtonClick: Function = () => controller.action(ACTION_TYPES.noScoresClick, emptyStateParams)

  if (hasGames && entity) {
    return null;
  }

  const emptyStateParams = {
    entityId: entity?.id,
    entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[entity?.objectType],
    filter: filterName || ENTITY_SCORES.ANALYTICS.FILTERS.recentMatches,
    sportTypeId: entity?.sport?.id
  }

  const buttonProps = {
    className: classNames(styles.button),
    model: filterEmptyStateModel,
    onClick: onFilterChange ? () => onFilterChange(filterEmptyStateIndex) : () => linkButtonClick()
  }

  return (
    <div className={classNames(styles.container)}>
      <SportTypeEmptyState sportTypeId={sport?.id} text={emptyStateText} isSmallView={isSmallView}/>
      <Link {...buttonProps}>{emptyStateButtonLabel}</Link>
    </div>
  )
});
